import { useState, useEffect } from 'react';
import { Download } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export function Footer() {
    const currentYear = new Date().getFullYear();
    const [hasCV, setHasCV] = useState(false);

    useEffect(() => {
        // Check if CV is available
        fetch(`${API}/settings`)
            .then(res => res.json())
            .then(data => {
                setHasCV(!!data.cv_filename);
            })
            .catch(() => setHasCV(false));
    }, []);

    const handleDownloadCV = () => {
        window.open(`${API}/cv/download`, '_blank');
    };

    return (
        <footer className="bg-card border-t-2 border-border py-12" data-testid="footer">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col md:flex-row justify-between items-center gap-8">
                    {/* Logo */}
                    <div className="text-center md:text-left">
                        <span 
                            className="text-2xl font-bold text-primary"
                            style={{ fontFamily: "'Silkscreen', cursive" }}
                        >
                            SHREYAN
                        </span>
                    </div>

                    {/* Download CV Button */}
                    {hasCV && (
                        <button
                            onClick={handleDownloadCV}
                            className="flex items-center gap-2 px-5 py-2.5 bg-primary text-primary-foreground hover:bg-primary/90 transition-colors text-xs uppercase tracking-widest border-2 border-primary"
                            style={{ fontFamily: "'Silkscreen', cursive" }}
                            data-testid="download-cv-btn"
                        >
                            <Download className="h-4 w-4" />
                            Download CV
                        </button>
                    )}
                </div>

                {/* Bottom bar */}
                <div className="mt-8 pt-8 border-t-2 border-dashed border-border flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-muted-foreground uppercase tracking-widest">
                    <p>© {currentYear} Shreyan Sahukar. All rights reserved.</p>
                    <div className="flex items-center gap-1">
                        <span>Built with</span>
                        <span className="text-primary">♥</span>
                        <span>and pixels</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}
